import { render, staticRenderFns } from "./HeroUpgradeLeaderboard.vue?vue&type=template&id=5d0e2df2&scoped=true"
import script from "./HeroUpgradeLeaderboard.vue?vue&type=script&lang=js"
export * from "./HeroUpgradeLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./HeroUpgradeLeaderboard.vue?vue&type=style&index=0&id=5d0e2df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e2df2",
  null
  
)

export default component.exports